import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import DatePicker from "react-datepicker";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";

export default class SearchForm extends Component {
    constructor(props) {
        super(props)
        this.state = {
            id: '',
            messase_thread_job_id: '',
            client_id: '',
            staff_id: '',
            from_date: null,
            to_date: null,
        }
        this.handleChangeFromDate = this.handleChangeFromDate.bind(this);
        this.handleChangeToDate = this.handleChangeToDate.bind(this);
        this.handleFieldChange = this.handleFieldChange.bind(this);
        this.handleSearchData = this.handleSearchData.bind(this);
        this.resetInputField = this.resetInputField.bind(this);
    }
    
    /**
     * Call search data by text
     */
    handleSearchData() {
        const searchForm = {
            id: this.state.id,
            messase_thread_job_id: this.state.messase_thread_job_id,
            client_id: this.state.client_id,
            staff_id: this.state.staff_id,
            from_date: this.state.from_date ? this.state.from_date.format("YYYY-MM-DD HH:mm") : '',
            to_date: this.state.to_date ? this.state.to_date.format("YYYY-MM-DD HH:mm") : '',
        };
        if (typeof this.props.onSearch === 'function') {
            this.props.onSearch(searchForm);
        }
    }
    
    /**
     * Process change date interview
     */
    handleChangeFromDate(date) {
        this.setState({
          from_date: date,
        });
    }
    
    /**
     * Process change date create at
     */
    handleChangeToDate(date) {
        this.setState({
          to_date: date,
        });
    }
    
    /**
     * Process field change
     */
    handleFieldChange(event) {
        this.setState({
            [event.target.name]: event.target.value
        }) 
    }
    
    /**
     * Clear data input field
     */
    resetInputField() {
        this.setState({
            id: '',
            messase_thread_job_id: '',
            client_id: '',
            staff_id: '',
            from_date: null,
            to_date: null,
        });
    }
    
    render() {
        return(
            <div className="collapse multi-collapse" id="search-messages">
                <div className="card mt-3">
                    <div className="card-header">メッセージを検索する条件</div>
                    <div className="card-body">
                        <div className="row">
                            <div className="col-sm-4">
                                <div className="form-group">
                                    <label className="form-label" htmlFor="">ID</label>
                                    <input type="text" name="id" onChange={this.handleFieldChange} value={this.state.id} className="form-control" placeholder="ID"/>
                                </div>
                            </div>
                            <div className="col-sm-4">
                                <div className="form-group">
                                    <label className="form-label" htmlFor="">依頼ID</label>
                                    <input type="text" name="messase_thread_job_id" onChange={this.handleFieldChange} value={this.state.messase_thread_job_id} className="form-control" placeholder="依頼ID"/>
                                </div>
                            </div>
                            <div className="col-sm-4">
                                <div className="form-group">
                                    <label className="form-label" htmlFor="">ワーカーID</label>
                                    <input type="text" name="staff_id" onChange={this.handleFieldChange} value={this.state.staff_id} className="form-control" placeholder="ワーカーID"/>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-4">
                                <div className="form-group">
                                    <label className="form-label" htmlFor="">依頼者ID</label>
                                    <input type="text" name="client_id" onChange={this.handleFieldChange} value={this.state.client_id} className="form-control" placeholder="依頼者ID"/>
                                </div>
                            </div>
                            <div className="col-sm-4">
                                <div className="form-group">
                                    <label className="form-label" htmlFor="">検索開始日</label>
                                    <div className="input-group">
                                        <DatePicker
                                            locale="ja-JP"
                                            className="form-control form_datepicker"
                                            dateFormat="YYYY/MM/DD HH:mm"
                                            selected={this.state.from_date}
                                            onChange={this.handleChangeFromDate}
                                            showTimeSelect
                                            timeFormat="HH:mm"
                                            timeIntervals={15}
                                            timeCaption="時間"
                                            placeholderText="検索開始日"
                                            disabledKeyboardNavigation
                                        />
                                        <div className="input-group-append">
                                            <button className="btn btn-outline-secondary" type="button" id="form-calendar"><i className="material-icons">calendar_today</i></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-4">
                                <div className="form-group">
                                    <label className="form-label" htmlFor="">検索終了日</label>
                                    <div className="input-group">
                                        <DatePicker
                                            locale="ja-JP"
                                            className="form-control form_datepicker"
                                            dateFormat="YYYY/MM/DD HH:mm"
                                            minDate={this.state.from_date}
                                            selected={this.state.to_date}
                                            onChange={this.handleChangeToDate}
                                            showTimeSelect
                                            timeFormat="HH:mm"
                                            timeIntervals={15}
                                            timeCaption="時間"
                                            placeholderText="検索終了日"
                                            disabledKeyboardNavigation
                                        />
                                        <div className="input-group-append">
                                            <button className="btn btn-outline-secondary" type="button" id="form-calendar"><i className="material-icons">calendar_today</i></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card-footer text-center">
                        <button type="reset" className="btn btn-light" onClick={this.resetInputField}>リセット</button>
                        <button onClick={this.handleSearchData} type="submit" className="btn btn-secondary">検索する</button>
                    </div>
                </div>
            </div>
        );
    }
}